<div class="d-flex justify-content-between">
    <div class="form-group" *ngIf="selectedName != null">
      <div class="dropdown dropdown-bhp">
        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
          <input class="dropdown-toggle" [ngModel]="selectedName | translate" type="text" readonly />
          <span class="label-dropdown"></span>
          <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
        </div>
        <ul class="dropdown-menu">
          <li class="dropdown-item" (click)="onSelectChange('overallCompliance')" value="overallCompliance" [ngClass]="select === 'overallCompliance' ? 'active' : ''" >{{ 'DASHBOARD.OVERALL_COMPLIANCE' | translate }}</li>
          <li class="dropdown-item" (click)="onSelectChange('5Moments')" value="5Moments" [ngClass]="select === '5Moments' ? 'active' : ''" >{{ translationKeys.Dashboard.FiveMoments | translate }}</li>
          <li class="dropdown-item" (click)="onSelectChange('beforeAsepticProcedures')" value="beforeAsepticProcedures" [ngClass]="select === 'beforeAsepticProcedures' ? 'active' : ''" >{{ 'EVALUATION.STATISTICS_ASEPT' | translate }}</li>
          <li class="dropdown-item" (click)="onSelectChange('individualData')" value="individualData" [ngClass]="select === 'individualData' ? 'active' : ''" >{{ 'EVALUATION.OVERVIEW_INDIVIDUAL_DATA_1' | translate }}</li>
          <li class="dropdown-item" (click)="onSelectChange('comments')" value="comments" [ngClass]="select === 'comments' ? 'active' : ''" >{{ 'EVALUATION.COMMENTS' | translate }}</li>
          <li class="dropdown-item" (click)="onSelectChange('quota')" value="quota" [ngClass]="select === 'quota' ? 'active' : ''" >{{ translationKeys.Configure.Quota | translate }}</li>
      </ul>
      </div>
    </div>

</div>
<kendo-excelexport [data]="gridData" [fileName]="getFileName('xlsx')" #excelexport>
    <kendo-excelexport-column field="{{i.field}}" title="{{i.title | translate}}" *ngFor="let i of fields,  let indexx = index;" class="non-action-columns" [width]="i.width">
    </kendo-excelexport-column>
</kendo-excelexport>

<kendo-excelexport [data]="gridData" [fileName]="getFileName('xlsx','ObservationDetails')" #excelexportObservationDetails>
    <kendo-excelexport-column [field]="field.field" [title]="field.title | translate" *ngFor="let field of observationDetailsExcelFields" class="non-action-columns" [width]="field.width"></kendo-excelexport-column>
</kendo-excelexport>

<ng-container *ngFor="let result of results">
  <kendo-excelexport [data]="result.gridData" filename="ReportMyHygieneSOP.xlsx" #multiselectExcelExport>
    <kendo-excelexport-column field="{{i.field}}" title="{{i.title | translate}}"
        *ngFor="let i of result.fields,  let indexx = index;" class="non-action-columns" [width]="i.width">
       <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="i.ngTemplate">
        {{i.ngTemplate(dataItem)}}
        </ng-template>
    </kendo-excelexport-column>
  </kendo-excelexport>
</ng-container>